import { render, staticRenderFns } from "./ProActionPlanStep2Form.vue?vue&type=template&id=63af4532&"
import script from "./ProActionPlanStep2Form.vue?vue&type=script&lang=ts&"
export * from "./ProActionPlanStep2Form.vue?vue&type=script&lang=ts&"
import style0 from "./ProActionPlanStep2Form.vue?vue&type=style&index=0&id=63af4532&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports